import { render, staticRenderFns } from "./h-percentage-field.vue?vue&type=template&id=123a90a0&lang=html"
import script from "./h-percentage-field.vue?vue&type=script&lang=js"
export * from "./h-percentage-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports